//React
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
//Styling
import "./picklist.scss";
//Mui
import { Modal, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
//Utils
import {
  getSites,
  getSuppliers,
  getPicklistStatuses,
  getAllPicklists,
  mergePicklists,
} from "../../utils/api";
import { handleAlert } from "../../utils/alert";
//Components
import MainAlert from "../reusables/MainAlert";
import Loader from "../reusables/Loader";
import MergeIcon from "@mui/icons-material/Merge";
export default function AdminPicklist() {
  //URL
  const url = process.env.REACT_APP_NITROPOS;
  const navigate = useNavigate();
  //Picklists
  const [allPickLists, setAllPicklists] = useState<any>([]);
  const [allPickListsFixed, setAllPicklistsFixed] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  //Filters
  const [suppliers, setSuppliers] = useState<any>([]);
  const [statuses, setStatuses] = useState<any>([]);

  //Alert & Loader
  const [alert, setAlert] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [severity, setSeverity] = useState<any>("");
  const [loader, setLoader] = useState<boolean>(true);
  const [empty, setEmpty] = useState<boolean>(true);
  useEffect(() => {
    //Get user authorised supplier from localstorage
    let _suppliers = [];
    let userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      let parsedUserDetails = JSON.parse(userDetails);
      if (parsedUserDetails.suppliers) {
        _suppliers = JSON.parse(parsedUserDetails.suppliers);
      }
    }

    document.addEventListener("click", function (e: any) {
      const { statusid, plheadid } = e.target.dataset;
      if (e.target.className === "d" && statusid !== 3) {
        navigate(`${plheadid}`);
      }
    });
    //If authorised will navigate to home in order to strip params
    // navigate("/");
    //Bring in Picklists - 50 limit / page 1

    getAllPicklists(50, currentPage).then((res: any) => {
      if (res === "error") {
        handleAlert(
          "Sorry unable to get picklists - Please try again",
          "error",
          setMessage,
          setSeverity,
          setAlert
        );
      } else {
        let dupPiclists = [];
        dupPiclists = res.filter((e: any) => {
          if (
            e.statusId === 1 && 
            e.statusName === "Pending" &&
            e.main_list_id === null
          ) {
            return e;
          }
        });
        setAllPicklists(dupPiclists);
      }

      setLoader(false);
    });
  }, [currentPage]);

  const mergePickLists = async () => {
    const list: string[] = Array.from(
      document.querySelectorAll<HTMLInputElement>(
        'input[type="checkbox"]:checked'
      )
    ).map((checkbox) => checkbox.value);

    if (list.length > 1) {
      const res = await mergePicklists(list);
      if (res === "error") {
        setMessage("unable to merge! please try again");
        setAlert(true);
      } else {
        setMessage("Picklists have been merged successfully");
        setAlert(true);
      }
    } else {
      setMessage("Please select 2 or more picklists");
      setAlert(true);
    }
  };

  const splitPicklist = async () => {
    const list: string[] = Array.from(
      document.querySelectorAll<HTMLInputElement>(
        'input[type="checkbox"]:checked'
      )
    ).map((checkbox) => checkbox.value);

    if (list.length === 0) {
      setMessage("Select picklist to split");
      setAlert(true);
    } else if (list.length > 1) {
      setMessage("Select only one picklist to split");
      setAlert(true);
    } else {
      navigate(`picklist-split/${list[0]}`);
    }
  };

  return (
    <main className="picklist">
      <h1 className="main_heading">Warehouse Picklists</h1>{" "}
      {!loader ? (
        <>
          {/* <section className="filter_container">
            {" "}
            <select
              onChange={(e) => {
                filterOrders(parseInt(e.target.value), "site");
              }}
            >
              <option value={0}>Filter by site</option>
              {sites &&
                sites.map((site: any, i: number) => {
                  return (
                    <option key={i} value={site.epos}>
                      {site.name}
                    </option>
                  );
                })}
            </select>
            <select
              onChange={(e) => {
                filterOrders(parseInt(e.target.value), "supplier");
              }}
            >
              <option value={0}>Filter by Supplier</option>
              {suppliers &&
                suppliers.map((supplier: any, i: number) => {
                  return (
                    <option key={i} value={supplier.eposId}>
                      {supplier.name}
                    </option>
                  );
                })}
            </select>
            <select
              onChange={(e) => {
                filterOrders(parseInt(e.target.value), "status");
              }}
            >
              {" "}
              <option value={0}>Filter by Status</option>
              {statuses &&
                statuses.map((status: any, i: number) => {
                  return (
                    <option key={i} value={status.statusId}>
                      {status.name}
                    </option>
                  );
                })}
            </select>{" "}
          </section> */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "row",
              gap: "2vh",
              margin: "2vh",
              padding: "2vh",
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                mergePickLists();
              }}
            >
              Merge Picklists
            </Button>
            <Button variant="contained" onClick={() => {splitPicklist()}}>
              Split Picklist
            </Button>
          </div>

          {allPickLists.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Merged Pick List</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Supplier</th>
                  <th>Product Total</th>
                  <th>Status</th>
                  <th>Date Created</th>
                </tr>
              </thead>

              <tbody>
                {allPickLists &&
                  allPickLists.map((picklist: any, i: any) => {
                    return (
                      <tr
                        style={{
                          backgroundColor:
                            picklist.statusId === 3 ? "#b6fcc9" : "transparent",
                        }}
                      >
                        <td>
                          <input
                            type="checkbox"
                            name="action"
                            className="check"
                            value={picklist.plHeadId}
                          />
                        </td>
                        <td
                          className="d"
                          data-statusId={picklist.statusId}
                          data-plHeadId={picklist.plHeadId}
                        >
                          {picklist.merged ? <MergeIcon /> : "NO"}
                        </td>
                        <td
                          className="d"
                          data-statusId={picklist.statusId}
                          data-plHeadId={picklist.plHeadId}
                        >
                          {picklist.fromLocationName}
                        </td>
                        <td
                          className="d"
                          data-statusId={picklist.statusId}
                          data-plHeadId={picklist.plHeadId}
                        >
                          {picklist.toLocationName == null &&
                          picklist.supplierId == 200280
                            ? picklist.orderSource
                            : picklist.toLocationName}
                        </td>
                        <td
                          className="d"
                          data-statusId={picklist.statusId}
                          data-plHeadId={picklist.plHeadId}
                        >
                          {picklist.supplierName}
                        </td>
                        <td
                          className="d"
                          data-statusId={picklist.statusId}
                          data-plHeadId={picklist.plHeadId}
                        >
                          {picklist.productTotal}
                        </td>
                        <td
                          className="d"
                          data-statusId={picklist.statusId}
                          data-plHeadId={picklist.plHeadId}
                        >
                          {picklist.statusName}
                        </td>
                        <td
                          className="d"
                          data-statusId={picklist.statusId}
                          data-plHeadId={picklist.plHeadId}
                        >
                          {moment(picklist.dateCreated).format(
                            "DD-MM-YY HH:mm"
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          ) : (
            <h1 className="empty_table_heading">
              There are no vending machine picklist orders.
            </h1>
          )}
        </>
      ) : (
        <Loader />
      )}
      <section className="pagination_btns">
        {" "}
        <Button
          onClick={() => {
            setCurrentPage(currentPage + 1);
            window.scrollTo(0, 0);
          }}
          disabled={allPickLists.length < 50}
          variant="contained"
        >
          <ArrowBackIcon />
        </Button>
        <h2>{currentPage}</h2>
        <Button
          onClick={() => {
            setCurrentPage(currentPage - 1);
            window.scrollTo(0, 0);
          }}
          disabled={currentPage === 1}
          variant="contained"
        >
          <ArrowForwardIcon />
        </Button>
      </section>
      <Modal open={alert}>
        <MainAlert message={message} severity={severity} closer={setAlert} />
      </Modal>
    </main>
  );
}
